@if (selectedControllers | findProperty: Property.isHvacHeatCool : null : true; as hvacHeatCoolProps) {
  @if (selectedControllers | findProperty: Property.isHvacHeatCoolAuto : null : true; as hvacHCAutoProps) {
    @if (selectedControllers | getRoomTemperatureData: location : (updated$ | async); as data) {

      <div class="margin-top50" style="width: max-content">
        <div>
          {{ areaName | translate }} -
          <!-- if hvac is in auto display range of temps -->
          {{
            (isAutoActive(hvacHCAutoProps)
              ? "HVAC inactive when temperature is in range"
              : "temperature set will be"
            ) | translate
          }}
        </div>

        <ul class="margin-left30">
          <li>{{ "Someone in room" | translate }}: {{ getBaseSetPropValue(data) }} ℃</li>

          <!-- Room rented but empty -->
          <li>
            {{ "Room rented but empty" | translate }}:
            @if (getBaseSetPropValue(data) === 0) {
              0
            } @else {
               <!-- Lower limit: Displayed if in AUTO mode OR HEATING mode (not cooling). Base - hyst1 -->
               {{ isAutoActive(hvacHCAutoProps) || !(hvacHeatCoolProps | propIsActive) ? getBaseSetPropValue(data) - getHyst1(data) : "" }}

               <!-- Only shown in AUTO mode for rooms (bathrooms show a single value) -->
               {{ isAutoActive(hvacHCAutoProps) && location !== "bathroom" ? " - " : "" }}

               <!-- Upper limit: Displayed if in AUTO mode OR COOLING mode Base + hyst1  -->
              {{ isAutoActive(hvacHCAutoProps) || (hvacHeatCoolProps | propIsActive) ? getBaseSetPropValue(data) + getHyst1(data) : "" }}
            }
            ℃
          </li>

          <!-- Room not rented -->
          <li>
            {{ "Room not rented" | translate }}:
            @if (getBaseSetPropValue(data) === 0) {
              0
            } @else {
              <!-- Lower limit: Base minus both hyst. Shown if in AUTO or HEATING mode -->
              {{ isAutoActive(hvacHCAutoProps) || !(hvacHeatCoolProps | propIsActive) ? getBaseSetPropValue(data) - getHyst1(data) - getHyst2(data) : "" }}

                <!-- Only shown in AUTO mode for rooms (bathrooms show a single value) -->
              {{ isAutoActive(hvacHCAutoProps) && location !== "bathroom" ? " - " : "" }}

              <!-- Upper limit: Base plus both hyst. Shown if in AUTO or COOLING mode -->
              {{ isAutoActive(hvacHCAutoProps) || (hvacHeatCoolProps | propIsActive) ? getBaseSetPropValue(data) + getHyst1(data) + getHyst2(data) : "" }}
            }
            ℃
          </li>
        </ul>

        <!-- Regulation Info - shown in heat/cool. NOT in auto -->
        @if (
          !isAutoActive(hvacHCAutoProps) &&
          location === "room" &&
          data.baseSetProp &&
          data.regulationProp
        ) {
          <div class="margin-top10">
            {{ "In room regulation is between" | translate }}
            @if (getBaseSetPropValue(data) === 0) {
              0 ℃ {{ "and" | translate }} 0 ℃
            } @else {
              {{ getBaseSetPropValue(data) - getRegulationPropValue(data) }} ℃ {{ "and" | translate | lowercase }}
              {{ getBaseSetPropValue(data) + getRegulationPropValue(data) }} ℃
            }
          </div>
        }
      </div>
    }
  }
}
